import {
    Container,
    Paper,
    Typography,
    Box,
    TextField,
    Button
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
export default function BankDetailsForm({

    data,

    errors,

    handleChange,

    onBack,

    onContinue

}) {

    return (

            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Bank Details

                </Typography>

                <Typography sx={{ mb: 4, color: "rgba(0,0,0,0.6)",}}>

                    Please note that we will not, under any circumstances, pay money into a third party account - the account details <strong>MUST</strong> belong to the employee.

                </Typography>


                <Box
                    sx={{
                        display: "grid",
                        gap: 2,
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr 1fr"
                        }
                    }}
                >

                    <TextField

                        label="Account Holder Name"

                        name="accountHolderName"

                        value={data.accountHolderName}

                        onChange={handleChange}

                        error={!!errors.accountHolderName}

                        helperText={errors.accountHolderName}

                        inputProps={{ maxLength: 100 }}

                    />


                    <TextField

                        label="Bank / Building Society"

                        name="bankBuildingSocietyName"

                        value={data.bankBuildingSocietyName}

                        onChange={handleChange}

                        error={!!errors.bankBuildingSocietyName}

                        helperText={errors.bankBuildingSocietyName}

                        inputProps={{ maxLength: 100 }}

                    />


                    <TextField

                        label="Branch"

                        name="branch"

                        value={data.branch}

                        onChange={handleChange}

                        error={!!errors.branch}

                        helperText={errors.branch}

                        inputProps={{ maxLength: 100 }}

                    />


                    <TextField

                        label="Sort Code"

                        name="sortCode"

                        placeholder="12-34-56"

                        value={data.sortCode}

                        onChange={(e) => {
                            let value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 6);

                            if (value.length > 2) {

                                value =
                                    value.slice(0, 2) +
                                    "-" +
                                    value.slice(2);

                            }

                            if (value.length > 5) {

                                value =
                                    value.slice(0, 5) +
                                    "-" +
                                    value.slice(5);

                            }

                            handleChange({

                                target: {

                                    name: "sortCode",

                                    value

                                }

                            });

                        }}

                        error={!!errors.sortCode}

                        helperText={
                            errors.sortCode ||
                            "Format: 12-34-56"
                        }

                    />


                    <TextField

                        label="Account Number"

                        name="accountNumber"

                        value={data.accountNumber}

                        onChange={(e) => {

                            handleChange({

                                target: {

                                    name: "accountNumber",

                                    value: e.target.value
                                        .replace(/\D/g, "")
                                        .slice(0, 8)

                                }

                            });

                        }}

                        error={!!errors.accountNumber}

                        helperText={errors.accountNumber}

                    />

                </Box>


                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 5
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>

                </Box>

            </Paper>

    );

}